import { RootState } from "../reducers";

type PrinterState = RootState;

const getPrinterHost = ({ printer }: PrinterState): string =>
  printer?.printerHost;

const getPrinterUrl = ({ printer }: PrinterState): string =>
  printer?.printerUrl;

export { getPrinterHost, getPrinterUrl };
